import { h } from 'preact';
import {useMemo, useState, useEffect} from "preact/compat";
import {MapFormatter} from "../../../utils";

export const useMobileSidebar = props => {
    // Destructured props
    const {
        data,
        selectedCategories
    } = props;

    // State to control the sidebar display state
    const [isOpen, setIsOpen] = useState(false);

    // Memo to store the label that should be displayed at the categories button
    const buttonLabel = useMemo(() => {
        // Main array to store the categories names
        const categories = [];
        // The formatted selected categories values
        const formattedSelectedCategories = MapFormatter(selectedCategories);

        for (let i = 0; i < data.length; i++) {
            // If root category doesn't have any child then it does nothing
            if (!data[i].childs) {
                continue;
            }

            data[i].childs.forEach(category => {
                // Checks if the category is in the selected ones and, if so,
                // appends its name to the "categories" array
                if (formattedSelectedCategories.includes(category.id)) {
                    categories.push(category.name);
                }
            })
        }

        return categories.length === 0 ?
            "Filtrar e organizar as categorias" :
            categories.join(" - ");
    }, [
        data,
        selectedCategories
    ]);

    // Method to handle the display state
    const handleMenu = () => {
        setIsOpen(prevState => !prevState);
    }

    // Handler for when the clear filters button is clicked
    const handleClearFilters = () => {
        try {
            document.querySelector("#categories-clear-button").click();
        } catch (err) {
            console.error("Error while clearing categories.");
        }
    }

    // Effect that will be fired immediately when the component is opened to deactivate the body overflow
    useEffect(() => {
        if (isOpen) {
            // Deactivates the body overflow
            document.body.classList.add("overflow-deactivate");

            return;
        }

        // Reactivates the body overflow
        document.body.classList.remove("overflow-deactivate");
    }, [isOpen])

    return {
        isOpen,
        buttonLabel,
        handleMenu,
        handleClearFilters
    }
}
